import { Box, Button, Flex, HStack, Text, Textarea } from '@chakra-ui/react';
import { useRef } from 'react';

interface MessageEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const VARIABLES = [
  { key: 'agent_name', label: 'Agent name', placeholder: '[Agent Name]' },
  { key: 'lender_name', label: 'Lender name', placeholder: '[Lender Name]' },
  { key: 'client_name', label: 'Client name', placeholder: '[Client Name]' },
];

export const MessageEditor = ({ value, onChange }: MessageEditorProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const insertVariable = (placeholder: string) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const newValue =
      value.substring(0, start) + placeholder + value.substring(end);
    onChange(newValue);

    // Reset cursor position after the inserted variable
    setTimeout(() => {
      textarea.selectionStart = start + placeholder.length;
      textarea.selectionEnd = start + placeholder.length;
      textarea.focus();
    }, 0);
  };

  return (
    <Box
      bg="whiteAlpha.50"
      border="1px solid"
      borderColor="whiteAlpha.100"
      borderRadius="lg"
      overflow="hidden"
    >
      {/* Variable Insertion Toolbar */}
      <Flex
        alignItems="center"
        bg="whiteAlpha.50"
        borderBottom="1px solid"
        borderColor="whiteAlpha.100"
        gap={6}
        px={5}
        py={3}
      >
        <Text
          color="whiteAlpha.700"
          fontSize="xs"
          letterSpacing="wider"
          textTransform="uppercase"
        >
          Insert variable
        </Text>
        <HStack spacing={2}>
          {VARIABLES.map((variable) => (
            <Button
              key={variable.key}
              _hover={{ bg: 'whiteAlpha.100' }}
              bg="whiteAlpha.50"
              border="1px solid"
              borderColor="whiteAlpha.100"
              borderRadius="sm"
              height="auto"
              px={2}
              py={1}
              transition="background 0.2s"
              type="button"
              variant="unstyled"
              onClick={() => insertVariable(variable.placeholder)}
            >
              <Text color="white" fontSize="sm" fontWeight="medium">
                {variable.label}
              </Text>
            </Button>
          ))}
        </HStack>
      </Flex>

      {/* Message Textarea */}
      <Textarea
        ref={textareaRef}
        _focus={{ boxShadow: 'none' }}
        _placeholder={{ color: 'whiteAlpha.400' }}
        bg="transparent"
        border="none"
        color="white"
        minHeight="150px"
        placeholder="Enter your notification message..."
        px={5}
        py={4}
        resize="none"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  );
};
